import React from "react";
import AutoResizeTextarea from "../AutoResizeTextarea";

const PanelFinancement = ({
  indicators,
  isDirty,
  setIsDirty,
  editableResult,
  setEditableResult,
}) => {
  // ── Extraction des données ──
  const client = indicators?.client || {};
  const cr = indicators?.compte_de_resultat || {};
  const bilan = indicators?.bilan || {};
  const immobilisations = indicators?.immobilisations || [];
  const emprunts = indicators?.emprunts || [];

  const exerciceN = client.exercice_N || "N";
  const exerciceN1 = client.exercice_N1 || "N-1";

  const dotationsN = cr.dotations_amortissements_N || 0;
  const resultatNetN = cr.resultat_net_N || 0;

  const immosBrutesN = bilan.immobilisations_brutes_N || 0;
  const immosBrutesN1 = bilan.immobilisations_brutes_N1 || 0;
  const cafN = bilan.caf_N || 0;
  const cafVarPct = bilan.caf_var_pct || 0;

  // ── Totaux emprunts ──
  const totalEmprunts = emprunts.reduce(
    (sum, e) => sum + (e.capital_restant || 0),
    0
  );
  const totalEcheancesMensuelles = emprunts.reduce(
    (sum, e) => sum + (e.echeance_mensuelle || 0),
    0
  );
  const totalEcheancesAnnuelles = totalEcheancesMensuelles * 12;

  const fmt = (v, d = 0) =>
    Number(v).toLocaleString("fr-FR", {
      minimumFractionDigits: d,
      maximumFractionDigits: d,
    });
  const fmtE = (v) => fmt(v) + " €";
  const fmtPct = (v) => (v >= 0 ? "+" : "") + fmt(v, 1) + "%";
  const deltaClass = (v) => (v >= 0 ? "pos" : "neg");
  const deltaArrow = (v) => (v >= 0 ? "▲" : "▼");

  const immoVariation = immosBrutesN - immosBrutesN1;

  return (
    <div className="fin-wrapper">
      <style>{`
        .fin-wrapper {
          --brand:#7E1738; --brand-mid:#9B1F44;
          --bg:#F5F3F7;
          --border:#E6E3EC; --border-light:#F0EDF4;
          --text:#1A1525; --text-2:#4A4460; --muted:#8A849A;
          --green:#16A34A; --green-bg:#F0FDF4; --green-mid:#DCFCE7;
          --amber:#D97706; --amber-bg:#FFFBEB; --amber-mid:#FEF3C7;
          --red:#DC2626; --red-bg:#FEF2F2; --red-mid:#FEE2E2;
          --purple:#7C3AED; --purple-bg:#F5F3FF; --purple-mid:#EDE9FE;
          --teal:#0891B2; --teal-bg:#ECFEFF; --teal-mid:#CFFAFE;
          --indigo:#4F46E5; --indigo-bg:#EEF2FF; --indigo-mid:#C7D2FE;
          --radius:10px;
          font-family:'DM Sans',system-ui,sans-serif;
          color:var(--text);
          font-size:13px;
          padding:20px 28px 32px;
          background:var(--bg);
          display:flex;
          flex-direction:column;
          gap:16px;
        }

        /* KPI 3 col */
        .fin-kpi-grid3{
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:14px;
        }
        .fin-kpi-card{
          background:var(--kpi-bg,var(--teal-bg));
          border:1px solid var(--kpi-mid,var(--teal-mid));
          border-radius:var(--radius);
          padding:16px 18px;
          display:flex;
          flex-direction:column;
          gap:3px;
          transition:transform .15s,box-shadow .15s;
        }
        .fin-kpi-card:hover{
          transform:translateY(-1px);
          box-shadow:0 4px 16px rgba(0,0,0,.07);
        }
        .fin-kpi-number{
          font-size:20px;
          font-weight:700;
          color:var(--kpi-color,var(--teal));
          line-height:1.1;
          letter-spacing:-.02em;
        }
        .fin-kpi-lbl{
          font-size:11px;
          font-weight:500;
          color:var(--kpi-color,var(--teal));
          opacity:.75;
          margin-top:1px;
        }
        .fin-kpi-delta{
          display:inline-flex;
          align-items:center;
          font-size:10.5px;
          font-weight:500;
          padding:2px 8px;
          border-radius:20px;
          margin-top:5px;
          width:fit-content;
        }
        .fin-kpi-delta.neg{background:rgba(220,38,38,.1);color:#B91C1C}
        .fin-kpi-delta.pos{background:rgba(22,163,74,.1);color:#15803D}
        .fin-kpi-delta.neu{background:rgba(100,100,120,.08);color:var(--text-2)}
        .kpi-teal{--kpi-bg:var(--teal-bg);--kpi-mid:var(--teal-mid);--kpi-color:var(--teal)}
        .kpi-purple{--kpi-bg:var(--purple-bg);--kpi-mid:var(--purple-mid);--kpi-color:var(--purple)}
        .kpi-amber{--kpi-bg:var(--amber-bg);--kpi-mid:var(--amber-mid);--kpi-color:var(--amber)}

        /* Grille 2 col */
        .fin-g2{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:14px;
          align-items:start;
        }
        .fin-col{
          display:flex;
          flex-direction:column;
          gap:14px;
        }

        /* Card */
        .fin-card{
          background:#fff;
          border:1px solid var(--border);
          border-radius:var(--radius);
          padding:18px 20px;
        }
        .fin-sec-label{
          font-size:10px;
          font-weight:700;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--muted);
          padding:4px 0 10px;
          border-bottom:1px solid var(--border);
          margin-bottom:14px;
        }

        /* Table */
        .fin-tbl-wrap{
          overflow-x:auto;
          border-radius:8px;
          border:1px solid var(--border);
        }
        .fin-tbl-wrap table{
          width:100%;
          border-collapse:collapse;
          font-size:12.5px;
        }
        .fin-tbl-wrap thead th{
          background:var(--bg);
          color:var(--text-2);
          padding:9px 12px;
          text-align:left;
          font-size:11px;
          font-weight:600;
          letter-spacing:.04em;
          border-bottom:1px solid var(--border);
          white-space:nowrap;
        }
        .fin-tbl-wrap thead th:not(:first-child){text-align:right}
        .fin-tbl-wrap td{
          padding:9px 12px;
          color:var(--text-2);
          border-bottom:1px solid var(--border-light);
          vertical-align:middle;
        }
        .fin-tbl-wrap td:not(:first-child){
          text-align:right;
          font-variant-numeric:tabular-nums;
        }
        .fin-tbl-wrap tbody tr:last-child td{border-bottom:none}
        .fin-tbl-wrap tbody tr:hover{background:var(--bg)}
        .fin-tbl-wrap .tr-tot td{
          background:var(--brand)!important;
          color:rgba(255,255,255,.95)!important;
          font-weight:600;
        }
        .sub-label{
          font-size:10.5px;
          color:var(--muted);
        }

        /* CAF box */
        .fin-caf-box{
          background:var(--brand);
          border-radius:var(--radius);
          padding:18px 20px;
        }
        .fin-caf-label-top{
          font-size:10px;
          font-weight:600;
          letter-spacing:.12em;
          text-transform:uppercase;
          color:rgba(255,255,255,.45);
          margin-bottom:12px;
        }
        .fin-caf-row{
          display:flex;
          justify-content:space-between;
          font-size:12.5px;
          color:rgba(255,255,255,.6);
          padding:7px 0;
          border-bottom:1px solid rgba(255,255,255,.08);
        }
        .fin-caf-row-val{font-variant-numeric:tabular-nums}
        .fin-caf-total{
          border-bottom:none!important;
          color:#fff!important;
          font-weight:700;
          padding-top:10px;
          margin-top:4px;
          border-top:1px solid rgba(255,255,255,.2);
        }
        .fin-caf-total .fin-caf-row-val{font-size:20px}

        /* Bilan row */
        .fin-bilan-row{
          display:flex;
          justify-content:space-between;
          align-items:baseline;
          padding:7px 0;
          font-size:12.5px;
          border-bottom:1px solid var(--border-light);
        }
        .fin-bilan-label{color:var(--muted)}
        .fin-bilan-val{
          font-weight:600;
          color:var(--text);
          font-variant-numeric:tabular-nums;
        }
        .fin-bilan-total{
          padding-top:10px;
          margin-top:4px;
          border-top:2px solid var(--text);
          border-bottom:none;
        }
        .fin-bilan-total .fin-bilan-label{font-weight:700;color:var(--text)}
        .fin-bilan-total .fin-bilan-val{
          font-size:18px;
          font-weight:700;
          color:var(--brand);
        }

        /* Tiles */
        .fin-tile-analyse{
          background:var(--indigo-bg);
          border:1px solid var(--indigo-mid);
          border-left:3px solid var(--indigo);
          border-radius:var(--radius);
          padding:16px 18px;
        }
        .fin-tile-analyse-head{
          display:flex;
          align-items:center;
          gap:8px;
          margin-bottom:10px;
        }
        .fin-tile-analyse-lbl{
          font-size:10px;
          font-weight:700;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--indigo);
        }
        .fin-tile-analyse p{
          font-size:12.5px;
          line-height:1.8;
          color:#3730A3;
        }
        .fin-tile-infos{
          background:#FDF0F3;
          border:1px solid #F2D0DA;
          border-left:3px solid var(--brand);
          border-radius:var(--radius);
          padding:16px 18px;
        }
        .fin-tile-infos-head{
          font-size:10px;
          font-weight:700;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--brand);
          margin-bottom:10px;
        }
        .fin-tile-infos p{
          font-size:12.5px;
          line-height:1.8;
          color:var(--text-2);
        }
      `}</style>

      {/* ── KPI 3 col ── */}
      <div className="fin-kpi-grid3">
        <div className="fin-kpi-card kpi-teal">
          <div className="fin-kpi-number">{fmtE(totalEmprunts)}</div>
          <div className="fin-kpi-lbl">Encours total emprunts</div>
          <span className="fin-kpi-delta neu">{emprunts.length} ligne(s)</span>
        </div>

        <div className="fin-kpi-card kpi-purple">
          <div className="fin-kpi-number">{fmtE(cafN)}</div>
          <div className="fin-kpi-lbl">Capacité d'autofinancement</div>
          <span className={`fin-kpi-delta ${deltaClass(cafVarPct)}`}>
            {deltaArrow(cafVarPct)} {fmtPct(cafVarPct)} vs {exerciceN1}
          </span>
        </div>

        <div className="fin-kpi-card kpi-amber">
          <div className="fin-kpi-number">{fmtE(totalEcheancesAnnuelles)}</div>
          <div className="fin-kpi-lbl">Échéances annuelles estimées</div>
          <span className="fin-kpi-delta neg">
            {fmtE(totalEcheancesMensuelles)}/mois
          </span>
        </div>
      </div>

      {/* ── Grille 2 col : tableaux | résumé ── */}
      <div className="fin-g2">
        {/* COLONNE GAUCHE : Emprunts + Immobilisations */}
        <div className="fin-col">
          <div className="fin-card">
            <div className="fin-sec-label">Emprunts en cours</div>
            <div className="fin-tbl-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Prêt</th>
                    <th>Montant origine</th>
                    <th>Durée</th>
                    <th>Début</th>
                    <th>Capital restant</th>
                    <th>Échéance</th>
                    <th>Fin</th>
                  </tr>
                </thead>
                <tbody>
                  {emprunts.map((emp, i) => (
                    <tr key={i}>
                      <td>
                        {emp.nom}
                        <br />
                        <span className="sub-label">{emp.banque}</span>
                      </td>
                      <td>{fmtE(emp.montant_origine)}</td>
                      <td>{emp.duree}</td>
                      <td>{emp.date_debut}</td>
                      <td style={{ fontWeight: 600, color: "var(--brand)" }}>
                        {fmtE(emp.capital_restant)}
                      </td>
                      <td>{fmtE(emp.echeance_mensuelle)}/mois</td>
                      <td>{emp.fin_contrat}</td>
                    </tr>
                  ))}
                  <tr className="tr-tot">
                    <td colSpan={4}>Total</td>
                    <td>{fmtE(totalEmprunts)}</td>
                    <td>{fmtE(totalEcheancesMensuelles)}/mois</td>
                    <td>—</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="fin-card">
            <div className="fin-sec-label">Immobilisations</div>
            <div className="fin-tbl-wrap">
              <table>
                <thead>
                  <tr>
                    <th>N°</th>
                    <th>Désignation</th>
                    <th>Date acq.</th>
                    <th>Durée</th>
                    <th>Valeur brute</th>
                    <th>Amort. cumulés</th>
                    <th>VNC</th>
                  </tr>
                </thead>
                <tbody>
                  {immobilisations.map((immo, i) => {
                    const amort = immo.valeur_entree - immo.vnc;
                    return (
                      <tr key={i}>
                        <td>{immo.numero}</td>
                        <td>
                          {immo.designation}
                          <br />
                          <span className="sub-label">{immo.compte}</span>
                        </td>
                        <td>{immo.date_acquisition}</td>
                        <td>{immo.duree}</td>
                        <td>{fmtE(immo.valeur_entree)}</td>
                        <td>{fmtE(amort)}</td>
                        <td
                          style={{
                            fontWeight: 600,
                            color: "var(--brand)",
                          }}
                        >
                          {fmtE(immo.vnc)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* COLONNE DROITE : CAF + Synthèse immos + Analyse + Reco */}
        <div className="fin-col">
          <div className="fin-caf-box">
            <div className="fin-caf-label-top">
              CAF — Capacité d'autofinancement {exerciceN}
            </div>
            <div className="fin-caf-row">
              <span>Résultat net {exerciceN}</span>
              <span className="fin-caf-row-val">{fmtE(resultatNetN)}</span>
            </div>
            <div className="fin-caf-row">
              <span>+ Dotations amortissements</span>
              <span className="fin-caf-row-val">{fmtE(dotationsN)}</span>
            </div>
            <div className="fin-caf-row fin-caf-total">
              <span>CAF {exerciceN}</span>
              <span className="fin-caf-row-val">{fmtE(cafN)}</span>
            </div>
          </div>

          <div className="fin-card">
            <div className="fin-sec-label">Immobilisations — Synthèse</div>
            <div className="fin-bilan-row">
              <span className="fin-bilan-label">Immo. brutes {exerciceN}</span>
              <span className="fin-bilan-val">{fmtE(immosBrutesN)}</span>
            </div>
            <div className="fin-bilan-row">
              <span className="fin-bilan-label">Immo. brutes {exerciceN1}</span>
              <span className="fin-bilan-val" style={{ color: "var(--muted)" }}>
                {fmtE(immosBrutesN1)}
              </span>
            </div>
            <div className="fin-bilan-row fin-bilan-total">
              <span className="fin-bilan-label">Variation</span>
              <span
                className="fin-bilan-val"
                style={{
                  color: immoVariation >= 0 ? "var(--green)" : "var(--red)",
                }}
              >
                {fmtE(immoVariation)}
              </span>
            </div>
          </div>

          <div
            className="rounded-md border-l-[3px] p-4"
            style={{ backgroundColor: "#EEF2FF", borderLeftColor: "#4F46E5" }}
          >
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs font-semibold text-indigo-700 uppercase tracking-wide">
                Analyse
              </p>

              {isDirty.analyseFinancement && (
                <span className="bg-amber-100 text-amber-700 border border-amber-200 text-[10px] px-2 py-0.5 rounded-md shadow-sm">
                  Modifié
                </span>
              )}
            </div>

            <AutoResizeTextarea
              value={editableResult?.financement_investissement?.analyse || ""}
              onChange={(e) => {
                setIsDirty((prev) => ({
                  ...prev,
                  analyseFinancement: true,
                }));
                setEditableResult((prev) => ({
                  ...prev,
                  financement_investissement: {
                    ...prev.financement_investissement,
                    analyse: e.target.value,
                  },
                }));
              }}
              className="text-indigo-900/80"
            />
          </div>

          <div
            className="rounded-md border-l-[3px] p-4"
            style={{ backgroundColor: "#FDF0F3", borderLeftColor: "#7E1738" }}
          >
            <div className="flex items-center justify-between mb-2">
              <p
                className="text-xs font-semibold uppercase tracking-wide"
                style={{ color: "#7E1738" }}
              >
                Informations & Recommandations
              </p>

              {isDirty.informations_recommandationsFinancement && (
                <span className="bg-amber-100 text-amber-700 border border-amber-200 text-[10px] px-2 py-0.5 rounded-md shadow-sm">
                  Modifié
                </span>
              )}
            </div>

            <AutoResizeTextarea
              value={
                editableResult?.financement_investissement
                  ?.informations_recommandations || ""
              }
              onChange={(e) => {
                setIsDirty((prev) => ({
                  ...prev,
                  informations_recommandationsFinancement: true,
                }));
                setEditableResult((prev) => ({
                  ...prev,
                  financement_investissement: {
                    ...prev.financement_investissement,
                    informations_recommandations: e.target.value,
                  },
                }));
              }}
              className="text-foreground/80"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelFinancement;
